module.exports = __webpack_public_path__ + "static/media/academy-video.cdc3db5c.mp4";